import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { ItemCategoryModel } from '../model/item-category.model';
import { ItemCategoryService } from '../item-category.service';
import { DepartmentService } from '../../../system/department/department.service';
@Component({
  selector: 'app-item-category-edit',
  templateUrl: './item-category-edit.component.html',
  styleUrls: ['./item-category-edit.component.scss'],
  standalone: false
})
export class ItemCategoryEditComponent {

  title: string = "New Item Category";
  editForm: FormGroup;
  itemCategoryInfo: ItemCategoryModel = {};
  isFormDirty: boolean = false;
  stock_item_category_id: any;
  selectedCategory: any;
  departmentList: any;
  super_category_id: any;
  isSubCategory: boolean = false;
  superCategoryList: any;


  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private departmentService: DepartmentService,
    private categoryService: ItemCategoryService,
    private snackBarService: SnackBarService,
    public dialog: MatDialog,) {

    let categoryId = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: this.builder.control(this.itemCategoryInfo.code, [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(this.itemCategoryInfo.name, [Validators.required, Validators.maxLength(50)]),
      department_id: this.builder.control(this.itemCategoryInfo.department_id),
      super_class_id: this.builder.control(this.itemCategoryInfo.super_class_id),




    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (categoryId !== null && parseInt(categoryId) !== 0) {
      this.setitemCategoryInfo(categoryId);
    }
  }
  ngOnInit(): void {
    //  this.loadRating(); 
    this.loadDepartmentList();
    this.loadCategoryList();
  }

  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  toggleCategoryDropdown() {
    this.isSubCategory = !this.isSubCategory;

    this.isFormDirty = true;
  }


  onCategoryChange(categoryId: any): void {
    let category = this.superCategoryList.find((cat: any) => (cat.id == categoryId));
    if (category != undefined) {
      let department = this.departmentList.find((dept: any) => (dept.id == category.department_id));
      if (department != undefined) {
        this.editForm.patchValue({
          department_id: department.id

        });

      }
    }
  }

  onDepartmentChange(): void {
    this.editForm.get('super_class_id')?.setValue(null);
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/product/item-category']);

  }

  /**
   * If tas is is null set an empty area info
   * if area id is not null call api to rtrive the info
   * @param areaId 
   */
  setitemCategoryInfo(categoryId: any): void {

    let response = this.categoryService.getById(categoryId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.itemCategoryInfo = response.data.category;
          this.editForm.patchValue(this.itemCategoryInfo);
          this.title = this.getTitle();
          this.isSubCategory = (this.itemCategoryInfo.super_class_id != undefined && this.itemCategoryInfo.super_class_id != 0)

          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.itemCategoryInfo.id == 0) ? "New Item Category" : "Editing : " + this.itemCategoryInfo.name;
    return title;
  }
  loadDepartmentList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "code", order: "asc" }],
      },
    };

    this.departmentService.getDepartmentList(requestData).subscribe(
      (response: {
        status: string;
        data: {
          departments: any;
          code: any[];
          base_uom_id: any[];
        };
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.departmentList = response.data.departments;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }

  loadCategoryList(): void {
    let requestData = {
      search: {
        filters: {
          column: [],
          scope: { limit: 100, offset: 0 },
        },
        sort: [{ column: "name", order: "asc" }],
      },
    };

    this.categoryService.getParentCategory(requestData).subscribe(
      (response: {
        status: string;
        data: {
          categories: any;

        };
        message: any;
      }) => {
        if (response.status === "SUCCESS") {
          this.superCategoryList = response.data.categories;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: "Failed!!!",
            type: "error",
          };
          this.snackBarService.openSnackBar(snackBarData);
        }
      }
    );
  }
  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {

    if (this.editForm.valid) {
      this.editForm.markAllAsTouched();
      if (!this.isSubCategory) {
        this.editForm.get('super_class_id')?.setValue(null);
      }
      Object.assign(this.itemCategoryInfo, this.editForm.value);
      this.categoryService.update(this.itemCategoryInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.itemCategoryInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/product/item-category']);

          } else if (response.code === 'DATA_CHANGED_AT_SERVER') {
            let snackBarData: SnackBarData = {
              message: 'This record has been updated by another user. Please reload the data to see the latest changes.',
              title: 'Conflict Detected',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
            // Refresh the data to show the latest version from server
            if (this.itemCategoryInfo.id) {
              this.setitemCategoryInfo(this.itemCategoryInfo.id);
            }
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });

    } else {
      this.editForm.markAllAsTouched();
    }
  }

}
